/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_State_LockedInputs */



/**
* | output |
* | --- |
* | "This account is locked after too many attempts. Ask your admin to unlock it." |
*
* @param {Signin_State_LockedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_state_locked = /** @type {((inputs?: Signin_State_LockedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_State_LockedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("This account is locked after too many attempts. Ask your admin to unlock it.")
});